import React from "react"

import { PopupWrapperElement } from "@front-shared/elements/popupWrapper.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import type { IPopupProps } from "@front-shared/types/props.types"

import type { INetworkStatusRulesFilters } from "../../types/networkStatus.types"
import { NetworkStatusRulesFiltersComponent } from "../networkStatus/filters/networkStatusRulesFilters.component"

import closeIcon from "@front-shared/assets/images/icons/close-dark.svg"

export const NetworkStatusRulesFilterPopupComponent: React.FunctionComponent<
    IPopupProps & {
        onFiltersSubmitted: (data: INetworkStatusRulesFilters) => void
        existingFilters: INetworkStatusRulesFilters
    }
> = props => {
    const onFiltersSubmitted = (data: INetworkStatusRulesFilters) => {
        props.onFiltersSubmitted(data)
        props.onDone()
    }

    return (
        <PopupWrapperElement
            isActive={props.isActive}
            className={props.className}
            onDone={props.onDone}
            closeOnOutsideClick={props.closeOnOutsideClick}
            ignoreOverlay
            popupWidthClassName="
                !w-screen !h-screen !rounded-none !shadow-none !p-0 !bg-transparent
            "
        >
            <div className="flex h-full">
                <div className="w-[755px] flex flex-col shadow-s bg-brand-offWhite md:w-full md:shadow-none">
                    <div
                        className="
                            flex items-center pl-[32px] pr-[16px] pt-[24px] pb-[16px]
                            border-b border-solid border-brand-warmLight
                        "
                    >
                        <PrimaryText
                            typography="h3"
                            className="flex-1 mr-[24px]"
                        >
                            Filters
                        </PrimaryText>

                        <div
                            className="cursor-pointer p-[16px]"
                            onClick={props.onDone}
                        >
                            <img src={closeIcon} alt="Close" title="Close" />
                        </div>
                    </div>

                    <NetworkStatusRulesFiltersComponent
                        className="w-full flex-1 overflow-y-auto"
                        existingFilters={props.existingFilters}
                        onFiltersSubmitted={onFiltersSubmitted}
                    />
                </div>

                <div className="flex-1 h-full backdrop-filter backdrop-blur-sm md:hidden" />
            </div>
        </PopupWrapperElement>
    )
}
